
import { WDFormInput } from './wd-form-input';

export class WDFormEmail extends WDFormInput {

  constructor(cfg)
  {
    cfg.type = 'email';
    super(cfg);
  };
  
  validate()
  {
		const data = this.val();

		if ( this.getAttribute('required') && ( data.length == '0' || this.isContentInvalid(data) ) )
		{
			this.markError();
			return false;
		}
		else if (data.length > 0 && this.isContentInvalid(data) )
		{
			this.markError();
			return false;
		}
		else
		{
			this.markSuccess();
			return true;
		}
	};

	isContentInvalid(data)
	{
		return ( data.indexOf("@")==-1 || data.indexOf(".")==-1 || data.indexOf(' ') != -1 );
	};
};

customElements.define('wd-form-email',WDFormEmail);

